/* =====================================================================
 * `/login` — the sign-in URL. Signed out, it shows the public landing
 * (which is the sign-in page, also served at `/`). Signed in, it sends
 * the user on to `?next=` or the tenant's default workspace page.
 * ===================================================================== */

import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { resolveTenantDefaultPath, useTenant } from '@auw/tenant';
import { AuthPage } from '@/components/auth/AuthPage';
import { safeReturnPath } from './authReturn';
import { SEOHead } from './SEOHead';

export const SignedOutLanding: React.FC = () => (
  <>
    <SEOHead
      title="AI 에이전트 워크스페이스"
      description="AI 에이전트와 대화하고, 문서를 작성하고, 이미지를 생성하세요. 팀 협업을 위한 올인원 AI 워크스페이스."
      canonicalPath="/"
    />
    <AuthPage />
  </>
);

export const LoginRoute: React.FC<{ isAuthed: boolean; authChecking: boolean }> = ({ isAuthed, authChecking }) => {
  const [searchParams] = useSearchParams();
  const tenant = useTenant();
  if (authChecking) return null;
  if (isAuthed) return <Navigate to={safeReturnPath(searchParams.get('next')) ?? resolveTenantDefaultPath(tenant)} replace />;
  return <SignedOutLanding />;
};
